import { createApp } from 'vue'
import Antd from 'ant-design-vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'ant-design-vue/dist/reset.css';
import '@/permission'

// if(process.env.NODE_ENV === 'development') require('../mock')
createApp(App).use(store).use(router).use(Antd).mount('#app')
